import { uid } from 'uid'
import { ref } from 'vue'

import { getEnvFromUrl } from './env'

export enum SESSION_CHANGE_REASONS {
  USER_CHANGED = 'user-changed',
  LOGGED_OUT = 'logged-out',
  SESSION_INVALID = 'session-invalid',
  ORG_CHANGED = 'org-changed',
}

export type BroadcastMessage = {
  tab: string
  message: SESSION_CHANGE_REASONS
}

export const broadcastTabId = uid()

let _broadcastChannel: BroadcastChannel | undefined

export function getBroadcastChannel(): BroadcastChannel | undefined {
  if (typeof window === 'undefined' || typeof BroadcastChannel === 'undefined') return undefined
  if (!_broadcastChannel) {
    _broadcastChannel = new BroadcastChannel(`ruminati_${getEnvFromUrl()}`)
  }
  return _broadcastChannel
}

// Single source of truth for session sync state — readable by any component (e.g. InternalLayout)
export const sessionChangedReason = ref<SESSION_CHANGE_REASONS | undefined>(undefined)

// Registered during auth initialization to avoid importing user state here (circular dependency).
let _hasActiveSession: (() => boolean) | undefined

export function setHasActiveSession(fn: () => boolean) {
  _hasActiveSession = fn
}

export function triggerLocalSessionChange(reason: SESSION_CHANGE_REASONS) {
  if (_hasActiveSession && !_hasActiveSession()) return
  sessionChangedReason.value = reason
}

export function sendBroadcastMessageFromTabIfFocused(message: SESSION_CHANGE_REASONS) {
  if (!document.hasFocus()) return
  getBroadcastChannel()?.postMessage({ tab: broadcastTabId, message })
}
